import ACTION_CONSTANTS from '../../constants/actionConstants';

/**
 * Navigate to a route with optional state and replace mode
 *
 * @param {string} route - The route path to navigate to
 * @param {object} state - Optional state to pass with navigation (accessible via location.state)
 * @param {boolean} replace - If true, replaces current history entry instead of pushing new one
 *
 * @example
 * Simple navigation
 * dispatch(navigateTo('/activities'))
 *
 * Navigation with state
 * dispatch(navigateTo('/submissions', { currentActivity }))
 *
 * Replace current entry
 * dispatch(navigateTo('/login', null, true))
 */
export const navigateTo = (route, state = null, replace = false) => ({
  type: ACTION_CONSTANTS.NAVIGATE_TO,
  payload: {
    navigation: {
      route,
      state,
      replace,
    },
  },
});

/**
 * Navigate back in history (like browser back button)
 *
 * @param {number} steps - Number of steps to go back (default: 1)
 *
 * @example
 * // Go back one page
 * dispatch(navigateBack())
 *
 * // Go back 2 pages
 * dispatch(navigateBack(2))
 */
export const navigateBack = (steps = 1) => ({
  type: ACTION_CONSTANTS.NAVIGATE_BACK,
  payload: { steps: -Math.abs(steps) },
});

/**
 * Navigate forward in history (like browser forward button)
 *
 * @param {number} steps - Number of steps to go forward (default: 1)
 *
 * @example
 * // Go forward one page
 * dispatch(navigateForward())
 *
 * // Go forward 2 pages
 * dispatch(navigateForward(2))
 */
export const navigateForward = (steps = 1) => ({
  type: ACTION_CONSTANTS.NAVIGATE_FORWARD,
  payload: { steps: Math.abs(steps) },
});
export const clearNavigation = () => ({
  type: ACTION_CONSTANTS.CLEAR_NAVIGATION,
});
